import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { label: 'Inicio', href: '/' },
  { label: 'Nosotros', href: '/nosotros' },
  { label: 'Servicios', href: '/servicios' },
  { label: 'Cobertura', href: '/cobertura' },
  { label: 'Contacto', href: '/contacto' },
];

const actionLinks = [
  { label: 'Consultar Deuda', href: '/consultar-deuda', variant: 'outline' },
  { label: 'Pagar Agua', href: '/pagar', variant: 'primary' },
];

export default function TopNav() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-foreground-950/85 backdrop-blur-md shadow-lg'
          : 'bg-foreground-950/50 backdrop-blur-sm'
      }`}
    >
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <nav className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 group">
            <img
              src="https://storage.readdy-site.link/project_files/418b164c-f08c-4ba4-9398-9b68655eb361/9c1b68bd-ebce-43c5-9051-a010ad0fba29_compressed_logotipo-comite-de-aguaxcf.webp"
              alt="CODESAJAN"
              className="h-10 w-10 md:h-12 md:w-12 object-contain transition-transform duration-300 group-hover:scale-105"
            />
            <div className="flex flex-col leading-tight">
              <span className={`font-heading font-bold text-sm md:text-base tracking-wide transition-colors ${scrolled ? 'text-white' : 'text-white'}`}>
                CODESAJAN
              </span>
              <span className={`text-[10px] md:text-xs font-medium tracking-wider transition-colors ${scrolled ? 'text-white/60' : 'text-white/70'}`}>
                AGUA — TARIJA
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden lg:flex items-center gap-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`px-3.5 py-2 rounded-lg text-sm font-medium whitespace-nowrap transition-all duration-300 ${
                    scrolled
                      ? active
                        ? 'text-accent-400 bg-white/10'
                        : 'text-white/80 hover:text-white hover:bg-white/10'
                      : active
                        ? 'text-white bg-white/15'
                        : 'text-white/85 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
          </div>

          {/* Desktop Actions */}
          <div className="hidden lg:flex items-center gap-2.5">
            {actionLinks.map((action) => (
              <Link
                key={action.href}
                to={action.href}
                className={`px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-all duration-300 ${
                  action.variant === 'primary'
                    ? 'bg-accent-500 text-white hover:bg-accent-600 shadow-sm'
                    : 'border border-white/30 text-white hover:bg-white/10'
                }`}
              >
                {action.label}
              </Link>
            ))}
          </div>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`lg:hidden p-2 rounded-lg transition-colors ${
              scrolled ? 'text-white hover:bg-white/10' : 'text-white hover:bg-white/10'
            }`}
            aria-label="Toggle menu"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-xl w-6 h-6 flex items-center justify-center`}></i>
          </button>
        </nav>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-foreground-950/98 backdrop-blur-lg border-t border-white/10 animate-fade-in">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => {
              const active = location.pathname === link.href;
              return (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                    active
                      ? 'text-accent-400 bg-white/10'
                      : 'text-white/80 hover:text-white hover:bg-white/10'
                  }`}
                >
                  {link.label}
                </Link>
              );
            })}
            <div className="pt-3 space-y-2 border-t border-white/10 mt-3">
              {actionLinks.map((action) => (
                <Link
                  key={action.href}
                  to={action.href}
                  className={`block px-4 py-3 rounded-lg text-sm font-semibold text-center transition-colors ${
                    action.variant === 'primary'
                      ? 'bg-accent-500 text-white hover:bg-accent-600'
                      : 'border border-white/20 text-white hover:bg-white/10'
                  }`}
                >
                  {action.label}
                </Link>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}